import createSagaMiddleware from 'redux-saga'

import { createBrowserHistory } from 'history'
import { createStore, applyMiddleware, compose } from 'redux'

import createRootReducer from './rootReducer'
import rootSaga from './rootSaga'
import { createReduxHistoryContext } from 'redux-first-history'

const {
  routerMiddleware,
  routerReducer,
  createReduxHistory,
} = createReduxHistoryContext({ history: createBrowserHistory() })

const sagaMiddleware = createSagaMiddleware()

const middlewares = [routerMiddleware, sagaMiddleware]

// if (process.env.NODE_ENV === 'development') {
//   // middlewares.push(logger)
// }

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  createRootReducer(routerReducer),
  composeEnhancers(applyMiddleware(...middlewares)),
)

export const history = createReduxHistory(store)

sagaMiddleware.run(rootSaga)
